"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextErrorFragment = void 0;
exports.nextErrorFragment = `
  fragment nextError on NextError {
    errorCode
    cid
  }
`;
//# sourceMappingURL=nextError.js.map